import React, { Component } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { connect } from 'react-redux'

import {
  productClickViewDetails,
  mapOfferInfoClick,
} from 'actions/AnalyticsActions'
import MultipleMarkers from 'components/Common/PropertyMap/MultipleMarkers'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import Spacing from 'components/Common/Spacing'
import Carousel from './Carousel'
import TextButton from 'components/Luxkit/Button/TextButton'

const StyledGrid = styled(LayoutContainer)`
  .slider-frame {
    margin: 0 ${rem(30)} !important; /* need to override carousel inline styles :(  */
  }
`

const CenterSpacing = styled(Spacing)`
  text-align: center;
`

interface Props {
  filters: App.OfferListFilters;
  offers: Array<App.Offer | App.OfferSummary>;
  markers?: Array<App.MapMarker>;
  loaded: boolean;
  showCarousel?: boolean;
  onProductClick?: () => void
  mapOfferInfoClick: (offer: App.Offer) => void
  productClickViewDetails: (offer: App.Offer) => void
}

class OfferMap extends Component<React.PropsWithChildren<Props>> {
  elements = {
    map: React.createRef<any>(),
    carousel: React.createRef<any>(),
  }

  onSelectPropertyMarker = (marker: App.MapMarker) => {
    if (this.elements.carousel.current) {
      this.elements.carousel.current.goToSlideForOffer(marker.propertyItem.offerId)
    }
  }

  onSlideChange = (offerId) => {
    this.elements.map.current.focusProperty(offerId)
  }

  render() {
    const {
      offers,
      loaded,
      markers,
      showCarousel,
    } = this.props

    return <>
      <MultipleMarkers
        ref={this.elements.map}
        offers={offers}
        markers={markers}
        height="535px"
        onSelectPropertyMarker={this.onSelectPropertyMarker}
        loaded={loaded}
        mapOptions={{
          scrollwheel: false,
        }}
      />

      {loaded && showCarousel &&
        <Pane>
          <PaneBody size="xl-y">
            <StyledGrid>
              <Carousel
                ref={this.elements.carousel}
                offers={offers}
                onSlideChange={this.onSlideChange}
              />
              <CenterSpacing mt={35}>
                <TextButton kind="primary" to="/" fit="mobile-full-width">View all escapes</TextButton>
              </CenterSpacing>
            </StyledGrid>
          </PaneBody>
        </Pane>
      }
    </>
  }
}

const mapDispatchToProps = {
  productClickViewDetails,
  mapOfferInfoClick,
}

export default connect(null, mapDispatchToProps)(OfferMap)
